import { firestore } from "../../firebase/firebase";

const errorReporter = (error, location, info, user) => {
  // ErrorFallBack already ran and set the reload keys, only report chunk errors once its reload cap engaged
  const isChunkError =
    error.name === 'ChunkLoadError' ||
    error.message?.includes('Loading chunk');

  if (isChunkError) {
    const lastReload = Number(sessionStorage.getItem('chunk_reload_at') || 0);
    const reloadCount = Number(sessionStorage.getItem('chunk_reload_count') || 0);
    if (reloadCount < 2 || Date.now() - lastReload < 10000) return;
  }

  // keep both reload keys through the clear or the cap in ErrorFallBack never engages
  if (isChunkError) {
    const chunkReloadAt = sessionStorage.getItem('chunk_reload_at');
    const chunkReloadCount = sessionStorage.getItem('chunk_reload_count');
    sessionStorage.clear();
    if (chunkReloadAt) sessionStorage.setItem('chunk_reload_at', chunkReloadAt);
    if (chunkReloadCount) sessionStorage.setItem('chunk_reload_count', chunkReloadCount);
  } else {
    sessionStorage.clear();
  }

  if (process.env.NODE_ENV === "development") {
    console.warn("Error report (dev, not sent):", error);
    return;
  }

  firestore
    .collection("crashReports")
    .add({
      name: error.name,
      description: error.message,
      stack: error.stack,
      componentStack: info?.componentStack || null,
      location: location.pathname,
      searchParams: location.search,
      timestamp: Date.now(),
      userEmail: user?.email || null,
      userName: user?.displayName || null,
      userAgent: navigator.userAgent,
    })
    .then(() => {
      console.warn("Error report sent.", error);
    });
};

export default errorReporter;
